// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../styles/global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questionnaire-page-template-right {
  width: calc(100% - 22.9375rem);
  height: 100%;
  margin-left: 22.9375rem;
  background-color: var(--background-color-darker);
  padding: 1.5rem 2.62rem;
  min-height: 100vh;
}

.questionnaire-hr {
  background: var(--grey);
  width: 100%;
  height: 0.0625rem;
  margin: 2.12rem 0rem;
}

.questionnaires {
  height: 100%;
}

@media (max-width: 1024px) {
  .questionnaire-page-template-right {
    width: 100%;
    margin-left: 0;
    padding: 1rem;
  }
}

.set-btn-color {
  background-color: #ee780bb5;
}

.scrollable-table-container {
  max-height: 600px; /* Adjust based on your row height */
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

/* Make table header sticky */
.scrollable-table-container table thead {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.scrollable-table-container {
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}

.scrollable-table-container::-webkit-scrollbar {
  width: 8px;
}

.scrollable-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.scrollable-table-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.scrollable-table-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.responses-answers-area {
  min-height: 650px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/questionnaire/questionnaireHistory.css"],"names":[],"mappings":"AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,gDAAgD;EAChD,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB,EAAE,oCAAoC;EACvD,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["@import \"../../styles/global.css\";\n\n.questionnaire-page-template-right {\n  width: calc(100% - 22.9375rem);\n  height: 100%;\n  margin-left: 22.9375rem;\n  background-color: var(--background-color-darker);\n  padding: 1.5rem 2.62rem;\n  min-height: 100vh;\n}\n\n.questionnaire-hr {\n  background: var(--grey);\n  width: 100%;\n  height: 0.0625rem;\n  margin: 2.12rem 0rem;\n}\n\n.questionnaires {\n  height: 100%;\n}\n\n@media (max-width: 1024px) {\n  .questionnaire-page-template-right {\n    width: 100%;\n    margin-left: 0;\n    padding: 1rem;\n  }\n}\n\n.set-btn-color {\n  background-color: #ee780bb5;\n}\n\n.scrollable-table-container {\n  max-height: 600px; /* Adjust based on your row height */\n  overflow-y: auto;\n  overflow-x: hidden;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n/* Make table header sticky */\n.scrollable-table-container table thead {\n  position: sticky;\n  top: 0;\n  background-color: white;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.scrollable-table-container {\n  scroll-behavior: smooth;\n  overscroll-behavior: contain;\n}\n\n.scrollable-table-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.scrollable-table-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.scrollable-table-container::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.scrollable-table-container::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.responses-answers-area {\n  min-height: 650px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
